angular.module('unergie.main')
.factory('Landscape', ($uibModal, $rootScope, LandscapeQuestions, ErrorCatcher) => {
    const openLandscape = function (idDraft, display, callBack = _.noop) {
        let landscapeDone = false
        return LandscapeQuestions.search({ category: 'c-est-parti', id_contract: idDraft, draft: true }).$promise
        .then((landscapeQuestionsResult) => {
            if (!display) {
                const lastBlock = landscapeQuestionsResult[landscapeQuestionsResult.length - 1]
                if (lastBlock && lastBlock[Object.keys(lastBlock).length - 1] && lastBlock[Object.keys(lastBlock).length - 1].last) {
                    landscapeDone = true
                }
            }

            const landscapeModal = $uibModal.open({
                animation: true,
                size: display ? 'xlg' : 'hidden',
                templateUrl: '/services/landscape/landscapeModal.html',
                backdrop: display ? 'static' : false,
                resolve: {
                    landscapeQuestions: () => landscapeQuestionsResult,
                    idContract: () => idDraft,
                    isEdition: () => ({ edition: false, new: display }),
                },
                controller($scope, $state, $uibModalInstance, $http, AlertManager, landscapeQuestions, idContract, isEdition) {
                    $scope.contractElec = { id: idContract }
                    $scope.landscapeQuestions = landscapeQuestions
                    $scope.popupInstance = $uibModalInstance
                    $scope.isEdition = isEdition.edition
                    $scope.isNew = isEdition.new

                    $scope.close = () => {
                        const landCanvas = document.getElementById('landscape-canvas')
                        return $uibModalInstance.close({ canvas: landCanvas })
                    }
                },
            })

            landscapeModal.rendered.then(() => $rootScope.$broadcast('landscapeModalReady', {}))

            return landscapeModal.result.then((result) => {
                result.landscapeDone = result.landscapeDone || landscapeDone
                result.landscapeVersion = 'v1-full'
                callBack(result)
                return result
            }).catch((error) => {
                if (error === 'escape key press') {
                    // Do nothing as modal.dismiss() emit this
                    return error
                }
                throw error
            })
        }).catch(ErrorCatcher)
    }

    const openSimplifiedLandscapeModal = (idDraft) => {
        return $uibModal.open({
            animation: true,
            size: 'lg',
            templateUrl: '/services/landscape/landscapeSimplifiedModal.html',
            backdrop: 'static',
            resolve: {
                idContract: () => idDraft,
            },
            controller($scope, $uibModalInstance, idContract) {
                $scope.idContract = idContract
                $scope.dismiss = $uibModalInstance.dismiss
                $scope.close = $uibModalInstance.close
            },
        })
    }

    return {
        openLandscape,
        openSimplifiedLandscapeModal,
    }
})
